// extracted by mini-css-extract-plugin
export const hideSidebar = "Pagenotes-module--hideSidebar--1k-Nu";
export const closeSidebar = "Pagenotes-module--closeSidebar--3eWWI";
export const sidebar = "Pagenotes-module--sidebar--oRi3X";
export const isActive = "Pagenotes-module--is-active--1y7R-";